<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  display: flex;
  flex-flow: column;
}
</style>



// WEBPACK FOOTER //
// src/App.vue